
import React from 'react';

interface Appointment {
    date: string;
    start: string;
    end: string;
    filledSlots: number;
    maxSlots: number;
}

interface AppointmentSlotsProps {
    appointments: Appointment[];
    userAppointments: any[];
    onBook: (date: string, start: string, end: string) => void;
}

const AppointmentSlots: React.FC<AppointmentSlotsProps> = ({ appointments, userAppointments, onBook }) => {
    const renderBookButton = (appt: Appointment) => {
        const isFull = appt.filledSlots >= appt.maxSlots;

        if (isFull) {
            return (
                <div className="text-center">
                    <span className="bg-red-100 text-red-600 px-4 py-2 rounded-lg font-medium block">
                        Filled
                    </span>
                    <p className="text-xs text-gray-500 mt-1 max-w-[150px]">
                        Contact the doctor for appointments in case of emergency
                    </p>
                </div>
            );
        }

        const isBooked = userAppointments.some(
            (appointment) =>
                appointment.date === appt.date &&
                appointment.start === appt.start &&
                appointment.end === appt.end
        );

        if (isBooked) {
            return (
                <div>
                    <span className="bg-red-100 text-red-600 px-4 py-2 rounded-lg font-medium block">
                        Booked
                    </span>
                </div>
            );
        }

        return (
            <button
                onClick={() => onBook(appt.date, appt.start, appt.end)}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
                Book
            </button>
        );
    };

    return (
        <div>
            <h2 className="text-2xl font-bold mb-3">Available Appointment Time</h2>
            <div className="space-y-4">
                {appointments.length === 0 && (
                    <p className="text-gray-500">No appointments available.</p>
                )}

                {appointments.map((appt, index) => (
                    <div
                        key={`${appt.date}-${appt.start}-${index}`}
                        className="bg-white p-4 rounded-lg shadow flex justify-between items-center border border-gray-200"
                    >
                        <div>
                            <p className="text-lg font-semibold text-indigo-700">{appt.date}</p>
                            <p className="text-gray-600">Doctor Available Time: {appt.start} - {appt.end} <span className='text-xs text-red-500'>First come first serve</span></p>

                            <p className="text-sm mt-1 text-gray-500">
                                Available appointments count: <b>{appt.maxSlots - appt.filledSlots}</b>
                            </p>
                        </div>

                        {renderBookButton(appt)}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AppointmentSlots;
